import React, { useState, useEffect } from "react";

const ColorPicker = ({ onColorSelect, defaultColor }) => {
  const [selectedColor, setSelectedColor] = useState(defaultColor);

  const handleColorChange = (event) => {
    const newColor = event.target.value;
    setSelectedColor(newColor);
    onColorSelect(newColor);
  };

  const getRandomColor = () => {
    let flips = 0;
    const dice = document.getElementById("dice");

    const flipAnimation = setInterval(() => {
      if (dice) {
        dice.style.transform = `rotate(${flips * 180}deg)`;
      }
      flips++;

      if (flips > 3) {
        clearInterval(flipAnimation);
        const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        setSelectedColor(randomColor);
        onColorSelect(randomColor);
      }
    }, 250); // Flip every 250ms, total duration ~1 second
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
      <input
        type="color"
        value={selectedColor}
        onChange={handleColorChange}
        style={{ cursor: "pointer" }}
      />
      <img
        id="dice"
        className="flippable"
        src="/icon/rand.png"
        height="30px"
        alt="Random Color"
        onClick={getRandomColor}
        style={{ cursor: "pointer", transition: "transform 0.25s" }}
      />
    </div>
  );
};

export default ColorPicker;
